import { h, Component, Fragment } from "preact";
import Config from "../../config";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MoneyFormatter from "../../utils/money-formatter";
import { FiltersRow, SelectFilter } from "../../utils/table-utils";
import { DateHelperFilter, PerPageFilter, TableFormatter } from "../../utils/form-utils";

import * as U from "../../desktop-templates/menu-user";
import * as I from "../../utils/icons";
import TicketLogic from "../../utils/ticket-logic";

import AwrabetTransactionsHistoryPage from "../../../awrabet/desktop-components/user/menu-transaction-history";

export default class TransactionsHistoryPage extends AwrabetTransactionsHistoryPage {
    tableColumns() {
        return [
            <strong class="block text-left body-bg-color"><Trans>ID</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Data</Trans></strong>,
            <strong class="block text-center body-bg-color"><Trans>Descrizione</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Importo</Trans></strong>,
            <strong class="block text-right body-bg-color"><Trans>Saldo</Trans></strong>
        ];
    }

    tableDataMapper(row) {
        const label = !!row['is-sender'] ? 'new_sender_balance' : 'new_receiver_balance';
        const message = row.description.rawmessage || row.description.message;
        return [
            <span class="block text-left">{row.idtransazione}</span>,
            <span class="block text-center">
                {new Date(row.ts * 1000).toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' })}
                &nbsp;
                {new Date(row.ts * 1000).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })}
            </span>,
            <span class="block text-left">
                {
                    message
                        .replace(/(ticketid:.?)([a-f0-9]{20})/i, '$1<a>$2<a>')
                        .split('<a>')
                        .map(
                            (item, i) => i === 1
                                ? <a href="javascript:void(0);" class="text-blue-700 hover:text-blue-500 hover:underline" onClick={e => TicketLogic.printTicket({ id: item, code: item })}>{item}</a>
                                : <span>{item}</span>
                        )
                }
            </span>,
            <span class={'block text-right ' + (parseFloat(row.amount) < 0 ? 'text-red-600' : 'text-green-600')}>
                {row.wallet_type == "bonus" ? '🎁' : ''}
                <MoneyFormatter value={row.amount} currency={row.currency} />
            </span>,
            <span class="block text-right"><MoneyFormatter value={row[label]} currency={row.currency} /></span>
        ];
    }

    render({ TableFormatterExt = TableFormatter }) {
        return <div>
            <U.SubTabsContainer>
                <U.Tab selected={true}>Storico</U.Tab>
            </U.SubTabsContainer>
            <div class="user-menu-header main-text-color p-2 text-base font-bold m-3 capitalize rounded"><Trans>Storico Movimenti</Trans></div>
            <FiltersRow class="gap-2 flex flex-col sm:flex-row p-2 text-sm sm:items-end justify-center">
                <label class="mx-px">
                    <span class="block text-xs"><Trans>Servizio</Trans></span>
                    <SelectFilter class="bg-white py-2" onChange={e => {
                        this.state.reasonFilter = e.target.value;
                        this.setState(this.state);
                    }}>
                        <option value=""><Trans>Select type</Trans></option>
                        <option value="deposits"><Trans>Deposit</Trans></option>
                        <option value="withdraws"><Trans>Withdraw</Trans></option>
                        <option value="voucher"><Trans>Vouchers</Trans></option>
                        <option value="B"><Trans>Sport bet</Trans></option>
                        <option value="W"><Trans>Sport win</Trans></option>
                        <option value="casino-bet"><Trans>Casino bet</Trans></option>
                        <option value="casino-win"><Trans>Casino win</Trans></option>
                    </SelectFilter>
                </label>
                <DateHelperFilter
                    {...this.state.dateFilter}
                    onInput={(dateFilter) => {
                        this.state.dateFilter = dateFilter;
                        this.setState(this.state);
                    }}
                />
                <PerPageFilter
                    perPage={this.state.perPage}
                    pageList={[10, 20, 30, 50, 100]}
                    onInput={
                        ({ perPage }) => {
                            this.state.perPage = perPage;
                            this.setState(this.state);
                        }
                    }
                />
                <a href="javascript:void(0);" class="px-4 py-2 sm:ml-5 bg-amber-400 text-black rounded" onClick={e => this.performSearch()}>
                    <Trans>Avvia Ricerca</Trans> <I.SearchIcon class="h-3 inline-block" />
                </a>
            </FiltersRow>
            <div class="text-sm mt-3">
                {this.state.response && this.state.response.totals && <div class="w-full flex justify-center p-2">
                    <div class="flex flex-col items-stretch gap-2 sm:gap-0 sm:flex-row sm:rounded sm:border sm:mx-auto w-full sm:w-auto text-center">
                        <div class="rounded sm:rounded-none border py-1 w-full sm:py-0 sm:w-48 sm:border-none sm:border-r"><div><Trans>Tot in</Trans></div><div class="text-base"><MoneyFormatter value={this.state.response.totals.in} /></div></div>
                        <div class="rounded sm:rounded-none border py-1 w-full sm:py-0 sm:w-48 sm:border-none sm:border-r"><div><Trans>Tot out</Trans></div><div class="text-base"><MoneyFormatter value={this.state.response.totals.out} /></div></div>
                        <div class="rounded sm:rounded-none border py-1 w-full sm:py-0 sm:w-48 sm:border-none"><div><Trans>Total</Trans></div><div class="text-base"><MoneyFormatter value={this.state.response.totals.tot} /></div></div>
                    </div>
                </div>}
                <TableFormatterExt
                    {...this.state.response}
                    style="font-family:'Arial rounded', Arial, sans-serif;"
                    columns={this.tableColumns()}
                    rowClass={'hover:bg-gray-200'}
                    rowDataMapper={this.tableDataMapper.bind(this)}
                    onNavigation={(newpage, newlowlimit) => this.changePage(newpage)}
                />
            </div>
        </div>;
    }
}